/**
 * Shared pricing-form constants (PricingTab, ScenarioPricerPage, NewLoanModal).
 *
 * WARNING: the OB_* occupancy/property-type enums here are the ScenarioPricerPage
 * ("origination/broker" pricer) vocabulary — e.g. OwnerOccupied, SingleFamilyResidence.
 * They are NOT the same vocabulary as the LOS_* enums in `losEnums.js`
 * (e.g. PrimaryResidence, SingleFamily), which come from the loan file / Vesta LOS.
 * Do not merge the two — they map to different backend value sets.
 *
 * US_STATES here is a plain list of 2-letter codes for form dropdowns (pricer,
 * broker signup). It is distinct from the `US_STATES` in
 * `services/mock/urlaEnumerations.js`, which is an array of `{ value, label }`
 * objects with full state names plus territories/military codes for address forms.
 */

export const LOCK_DURATIONS = [15, 30, 45];

export const PRODUCT_FAMILIES = [
  { id: 'Conventional', label: 'Conventional' },
  { id: 'FHA', label: 'FHA' },
  { id: 'VA', label: 'VA' },
  { id: 'USDA', label: 'USDA' },
  { id: 'Non-QM', label: 'Non-QM' },
];

/** ScenarioPricerPage occupancy vocabulary (OwnerOccupied / SecondHome / NonOwnerOccupied). */
export const OB_OCCUPANCY_OPTIONS = [
  { value: 'OwnerOccupied', label: 'Primary Residence' },
  { value: 'SecondHome', label: 'Second Home' },
  { value: 'NonOwnerOccupied', label: 'Investment Property' },
];

/** ScenarioPricerPage property-type vocabulary. */
export const OB_PROPERTY_TYPE_OPTIONS = [
  { value: 'SingleFamilyResidence', label: 'Single Family' },
  { value: 'Condo', label: 'Condominium' },
  { value: 'Cooperative', label: 'Cooperative' },
  { value: 'MultiUnit', label: 'Multi-Unit (2-4)' },
  { value: 'ManufacturedHome', label: 'Manufactured Home' },
  { value: 'PlannedUnitDevelopment', label: 'PUD' },
];

/** Plain 2-letter US state codes for pricer / broker signup dropdowns. */
export const US_STATES = [
  'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN',
  'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH',
  'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT',
  'VT', 'VA', 'WA', 'WV', 'WI', 'WY',
];
